import { createContext, useContext } from 'react';
import { GwpPartnerOffer } from '../PartnerLanding/useGwpPartnerProgram';

/**
 * The self-serve offer a redeem page sells, for its plan cards, which sit several components below the page. Null on
 * every other page, where the cards show their usual prices.
 */
export const GwpRedeemOfferContext = createContext<GwpPartnerOffer | null>(null);

export function useGwpRedeemOfferContext() {
  return useContext(GwpRedeemOfferContext);
}
